import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { HelmetProvider } from 'react-helmet-async'
import { BrowserRouter as Router } from 'react-router-dom'
import { CookieHelper } from 'Utils/cookieHelper'

import './app.scss'
import { queryClient } from 'Lib/react-query'

import { useUserStore } from 'Stores/userStoreModuleFed'
import { AppStyled } from 'Providers/app.styled'
import { COOKIE_KEYS, PARAMS_COOKIE_KEYS } from 'Consts/cookies.enum'
import { ErrorPage } from 'Features/errorPage/ErrorPage'

type AppProviderProps = {
  children: React.ReactNode
}

export const AppProvider = ({ children }: AppProviderProps) => {
  const { logIn } = useUserStore()

  useEffect(() => {
    const { getCookie, getLogicCookieData } = CookieHelper()
    const token = getCookie(COOKIE_KEYS.TOKEN) || ''
    const userId = getLogicCookieData(PARAMS_COOKIE_KEYS.USER_ID)
    const accountId = getLogicCookieData(PARAMS_COOKIE_KEYS.ACCOUNT_ID)
    const accountName = getLogicCookieData(PARAMS_COOKIE_KEYS.ACCOUNT_NAME)
    const networkId = getLogicCookieData(PARAMS_COOKIE_KEYS.NETWORK_ID)
    const subscriptionId = getLogicCookieData(PARAMS_COOKIE_KEYS.SUBSCRIPTION_ID)
    const isReactivation = getLogicCookieData(PARAMS_COOKIE_KEYS.IS_REACTIVATION)
    const owner = getLogicCookieData(PARAMS_COOKIE_KEYS.OWNER) == 'true'
    if (token.length) {
      logIn(
        token,
        parseInt(userId),
        parseInt(accountId),
        networkId,
        owner,
        parseInt(subscriptionId),
        accountName,
        !!isReactivation
      )
    }
  }, [logIn])

  return (
    <React.Suspense>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <HelmetProvider>
          <QueryClientProvider client={queryClient}>
            {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
            <AppStyled>
              <Router>{children}</Router>
            </AppStyled>
          </QueryClientProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </React.Suspense>
  )
}
